import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { getUserProfile } from '@topconagriculture/profiling';

import api from '../../../core/api';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { getCompaniesList } from './company.actions';
import { selectActions } from '../../actions';
import { getFarms } from '../farms/farms.selector';
import { Farm } from '../farms/farms.types';

export function* getCompaniesSaga() {
  try {
    const result = yield call(api.farms.getCompanies);
    yield put(
      getCompaniesList.done({
        params: {},
        result,
      }),
    );
    const user = yield select(getUserProfile);
    const farms: Farm[] = yield select(getFarms);
    if (result instanceof Array) {
      const userCompany = result.find((company) => company.id === user.company.id);
      const userFarms = farms.filter((farm) => farm.companyId === userCompany.id);
      yield call(api.setFarmId, userFarms[0].id);
      yield put(selectActions.setCurrentFarm(userFarms[0].id));
      yield put(selectActions.setSelectedCompany(userCompany.id));
    }
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* watchCompanySaga() {
  yield all([yield takeLatest(getCompaniesList.started, getCompaniesSaga)]);
}
